export function setVh() {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
}

let svhMeasureDiv = null;

export function setSvh() {
	// Reuse measuring div to avoid repeated DOM creation
	if (!svhMeasureDiv) {
		svhMeasureDiv = document.createElement('div');
		svhMeasureDiv.style.height = '100svh';
		svhMeasureDiv.style.position = 'absolute';
		svhMeasureDiv.style.visibility = 'hidden';
		svhMeasureDiv.style.pointerEvents = 'none';
	}

	// Add to DOM temporarily
	document.body.appendChild(svhMeasureDiv);

	// Get the computed height in pixels
	const heightInPx = svhMeasureDiv.getBoundingClientRect().height;

	// Clean up
	document.body.removeChild(svhMeasureDiv);

	const svh = heightInPx * 0.01;

	window._100svh = heightInPx;
	window._svh = svh;
	document.documentElement.style.setProperty("--svh", `${svh}px`);
}
